'use strict';

var React = require('react');
var ClassNames = require('classnames');
var SectionHeader = require('../Common/SectionHeader.jsx');
var AutoRebalancingActions = require('../../actions/AutoRebalancingActions.js');
var AutoRebalancingStore = require('../../stores/AutoRebalancingStore.js');
var InvestmentOptionStore = require('../../stores/InvestmentOptionStore');
var RadioInput = require('../Common/RadioInput.jsx');
var ApplicationConstants = require('../../constants/ApplicationConstants.js');
var ProductIds = ApplicationConstants.ProductIds;
var YesNoRadioData = ApplicationConstants.YesNoRadioData;
var AutoRebalancingConstants = require('../../constants/AutoRebalancingConstants.js');
var FrequencyData = AutoRebalancingConstants.FrequencyData;
var AutoRebalancingFields = AutoRebalancingConstants.AutoRebalancingFields;
var _ = require('lodash');
var YesNoValues = ApplicationConstants.YesNoValues;

function getAutoRebalancingState() {
    return {
        isAutoRebalancing: AutoRebalancingStore.getAutoRebalancing(),
        frequency: AutoRebalancingStore.getFrequency(),
        errorList: AutoRebalancingStore.getInlineErrorList(),
        hideFrequency: AutoRebalancingStore.isHideFrequency(),
        isManagedAccount: AutoRebalancingStore.getIsManagedAccount(),
        isPreRetirement: InvestmentOptionStore.getIsPreRetirement()
    };
}
var AutoRebalancingSection = React.createClass({
    getInitialState: function () {
        return getAutoRebalancingState();
    },
    componentDidMount: function () {
        AutoRebalancingStore.addChangeListener(this._onChange);
    },
    componentWillUnmount: function () {
        AutoRebalancingStore.removeChangeListener(this._onChange);
    },
    _onChange: function () {
        this.setState(getAutoRebalancingState());
    },
    handleChangeYesNo: function (e) {
        AutoRebalancingActions.updateAutoRebalancing({
            option: {
                value: e.target.value
            },
            frequency: {
                value: ''
            },
            changedField: AutoRebalancingFields.AUTO_REBALANCING_OPTIONS
        });
    },
    handleChangeFrequency: function (e) {
        AutoRebalancingActions.updateAutoRebalancing({
            frequency: {
                value: e.target.value
            },
            changedField: AutoRebalancingFields.FREQUENCY_OPTIONS
        });
    },
    getRefGuideNote: function () {
        var note, link;
        if (this.props.productId === ProductIds.SUPER || this.props.productId === ProductIds.PENSION) {
            link = <a key="superAndPensionGuide" href={this.props.content.autoRebalancing.superAndPensionGuide} target="_blank">Reference Guide</a>;
        }
        else if (this.props.productId === ProductIds.INVESTMENT) {
            link = <a key="investmentGuide" href={this.props.content.autoRebalancing.investmentGuide} target="_blank">Reference Guide</a>;
        }
        if(this.props.productId === ProductIds.SUPER || (this.props.productId === ProductIds.PENSION && !this.state.isPreRetirement)){
            note = [this.props.content.autoRebalancing.referenceGuideCopy, link, '.'];
        }else if(this.props.productId === ProductIds.INVESTMENT){
            note = [this.props.content.autoRebalancing.referenceGuideCopyCash, link, '.'];
        }else if(this.props.productId === ProductIds.PENSION && this.state.isPreRetirement){
            note = [this.props.content.autoRebalancing.referenceGuideCopyTTR, link, '.'];
        }

        return note;
    },
    getControlData(){
        var yesNoOptions = _.cloneDeep(YesNoRadioData);
        return {
            yesNoOptions: yesNoOptions,
            frequencyOptions: FrequencyData
        }
    },
    render: function () {

        // reference guide links
        var note = this.getRefGuideNote();
        var controlData = this.getControlData();
        return (this.state.isManagedAccount
            ? null
            : (<div className="form-step">
                    <SectionHeader focus={this.props.focus} sectionName="Auto-rebalancing" sectionHelpText="Need help?" NeedHelpInfo={this.props.content.autoRebalancing.autoRebalancingHelp} />
                    <div className="container">
                        <div className="auto-rebalancing">
                            <div className="form-section">
                                <RadioInput id="auto-rebalancing"
                                            data={controlData.yesNoOptions}
                                            value={this.state.isAutoRebalancing}
                                            label="Would you like to establish auto-rebalancing?"
                                            onChange={this.handleChangeYesNo}
                                            errorList={this.state.errorList}
                                            note={note} />
                            </div>
                            <div className={ClassNames('form-section',{hidden: this.state.hideFrequency ||(this.state.isAutoRebalancing === YesNoValues.YES && this.state.errorList.length)})}>
                                    <RadioInput id="auto-rebalancing-frequency"
                                                data={controlData.frequencyOptions}
                                                value={this.state.frequency}
                                                label="How often would you like to have your investments rebalanced?"
                                                onChange={this.handleChangeFrequency}
                                                errorList={this.state.errorList} />
                            </div>
                        </div>
                    </div>
            </div>)
        );
    }
});

module.exports = AutoRebalancingSection;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/AutoRebalancing/AutoRebalancingSection.jsx